import React from 'react';
import { Sparkles, Infinity as InfinityIcon } from 'lucide-react';
export function LifetimeAccessBonus() {
  return <div className="mt-8" data-id="element-337" data-mp="2iz4ivxy63bnr">
      <div className="bg-violet-50 rounded-3xl p-6 border-2 border-violet-200 shadow-lg relative overflow-hidden" data-id="element-338" data-mp="2iyuqy4tkauff">
        <div className="relative z-10 flex flex-col md:flex-row items-center gap-6" data-id="element-339" data-mp="2dyzxbtiejqqo">
          <div className="shrink-0 w-24 md:w-32" data-id="element-340" data-mp="2a1c20pcsrvy9">
            <img src="https://cdn.magicpatterns.com/uploads/q95pnAgWMR4B9QZwBL1Zcx/Diseno_sin_titulo.png" alt="Acceso Vitalicio" className="w-full h-auto drop-shadow-md" data-id="element-341" data-mp="36q9v834wfltb" />
          </div>

          <div className="flex-1 text-center md:text-left" data-id="element-342" data-mp="2xotny49drztb">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-violet-600 text-white text-[9px] font-black uppercase tracking-widest mb-3" data-id="element-343" data-mp="2xn8vck6mmqy3">
              <Sparkles size={10} data-id="element-344" data-mp="1may6upyx1gzg" />
              <span data-id="element-345" data-mp="1m7tw19qy3mzt">BONO EXTRA</span>
            </div>

            <h3 className="text-xl md:text-2xl font-black text-violet-950 uppercase italic mb-2 font-[Poppins]" data-id="element-346" data-mp="1hak85yj7fje3">
              Acceso <span className="text-violet-600" data-id="element-347" data-mp="2f07rkyxid8f">Vitalicio</span>
            </h3>

            <p className="text-violet-900/80 text-sm md:text-base leading-snug mb-3 font-medium" data-id="element-348" data-mp="7bqpsduaniwh">
              Un solo pago, acceso de por vida a todo el material y futuras
              actualizaciones. Sin mensualidades.
            </p>

            <div className="flex items-center justify-center md:justify-start gap-2 text-violet-600 font-black uppercase tracking-widest text-[10px]" data-id="element-349" data-mp="3ujm2o2rhl58t">
              <InfinityIcon size={14} data-id="element-350" data-mp="3kjldi06xruwp" />
              <span data-id="element-351" data-mp="3kkmracfc6vi4">INCLUIDO GRATIS</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}